export default "__VITE_ASSET__DkjhlwdF__"